/**
 * SpacerBlock Component
 * 
 * Adds vertical whitespace between blocks.
 * Useful for controlling layout rhythm and visual breathing room.
 */

import React, { memo } from 'react';
import { cn } from '@/lib/utils';
import { SpacerBlockProps } from '@/types/menuBuilder';

interface SpacerBlockComponentProps {
  props: SpacerBlockProps;
  isPreview?: boolean;
}

export const SpacerBlock = memo(function SpacerBlock({
  props,
  isPreview = false,
}: SpacerBlockComponentProps) {
  const { height } = props;

  return (
    <div
      style={{ height: `${height}px`, minHeight: `${height}px` }}
      className={cn(
        'w-full',
        // Show visual indicator in builder mode
        !isPreview && 'bg-muted/20 border border-dashed border-muted-foreground/20 rounded'
      )}
      aria-hidden="true"
    >
      {!isPreview && (
        <div className="h-full flex items-center justify-center">
          <span className="text-xs text-muted-foreground">
            Spacer ({height}px)
          </span>
        </div>
      )}
    </div>
  );
});

export default SpacerBlock;
